import { PremiumSectionItem } from "./premiumSectionItem.model"

export class PremiumRelatedSection {
    public visibleItems: PremiumSectionItem[]
    public itemsPerRow

    public constructor(
        public title: string,
        public cardType: string,
        public pluralLabel: string,
        public items: PremiumSectionItem[]
    ) {
        this.itemsPerRow = this.cardType === "mezzanine" ? 4 : 3
        this.visibleItems = this.items.slice(0, this.itemsPerRow)
    }

    public shouldShowLoadMore(): boolean {
        return this.items.length > this.visibleItems.length
    }

    public shouldShowLoadLess(): boolean {
        return this.visibleItems.length > this.itemsPerRow
    }

    public showMore() {
        if (this.visibleItems.length < this.items.length) {
            this.visibleItems = this.items
        }
    }

    public showLess() {
        this.visibleItems = this.items.slice(0, this.itemsPerRow)
    }

    public static fromData(data): PremiumRelatedSection {
        if (!data || !data.items || !data.items.length) {
            return null
        }
        const items = data.items.map((item_data) => PremiumSectionItem.fromData(item_data))
        return new PremiumRelatedSection(data.title, data.card_type, data.plural_label || "", items)
    }
}
